import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Option from './GridChoiceOption';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import QuestionPrompt from '../QuestionPrompt';//eslint-disable-line import/no-named-as-default
import DialogPrompt from '../DialogPrompt';
import Feedback from '../singleAnswer/SingleAnswerFeedback';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../../badges/BadgeCollect';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import * as xAPIHelper from '../../../../helpers/xAPIHelper';
import * as localStorage from '../../../../localStorage/localStorage';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import {MULTIPLE_CHOICE_REVIEW_CONFIG} from '../../../../models/dialogModels';
import * as animationHelper from "../../../../helpers/animationHelper";

class GridChoice extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            options: this.props.screenObject.options,
            locale: appHelper.getLocalData(this.props.screenObject),
            questionChecked: false,
            currentlyChecked: false,
            reviewMode: false,
            propsUpdated: false,
            responseData: {
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                asset_id: this.props.screenObject.asset_id,
                currentAttempt: 1,
                currentStatus: objectConstants.STATUS_NOT_STARTED,
                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                responses: [],
                latestResponse: {},
                scoring_type: this.props.screenObject.scoring_type

            },
            showOptions: false,
            enableCheckBtn: false,
            showCheckBtn: true,
            showFeedback: false,
            showResponse: false,
            revealedOptions: [],
            watchCheckBtnState: true,
            skipFeedback: false,
            screenStatus: "",
            checkObjectStatus: false,
            handleCompletion: false,
            checkPostXAPIResponse: false,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            show_images_in_feedback: false,
            focusedOption: this.props.screenObject.options[0],
            focusOnFeedback: false,
            optionCallbacks: {},
            updateFocus: false,
            showProgression: false,
            hideFeedback: false,
            progression_label: "",
            hasBadges: false,
            badgesCollected: false,
            animateBadge: true,
            submit_label: appHelper.getLocaleString("submit_label"),
            multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            try_again_label: appHelper.getLocaleString("try_again_label"),
            progressionHandled: false,
            xApiResponseObj: {},
            usePreviousUserObjectData: true,
            animatePrompt: false,
        };
        this.randomiseOptions = this.randomiseOptions.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.reattempt = this.reattempt.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.setCheckBtnState = this.setCheckBtnState.bind(this);
        this.handleSkipFeedback = this.handleSkipFeedback.bind(this);
        this.scrollToSubmitBtn = this.scrollToSubmitBtn.bind(this);
        this.getClass = this.getClass.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.handleResponseComplete = this.handleResponseComplete.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.hasFeedbackToShow = this.hasFeedbackToShow.bind(this);
        this.setFocusedOption = this.setFocusedOption.bind(this);
        this.clearFocusedOption = this.clearFocusedOption.bind(this);
        this.getPrevOption = this.getPrevOption.bind(this);
        this.getNextOption = this.getNextOption.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.allowKeyAccessibility = this.allowKeyAccessibility.bind(this);
        this.getTabIndex = this.getTabIndex.bind(this);
        this.onKeyboardPanelClick = this.onKeyboardPanelClick.bind(this);
        this.onFocusOnFeedback = this.onFocusOnFeedback.bind(this);
        this.setOptionCallbacks = this.setOptionCallbacks.bind(this);
        this.setOptionFocus = this.setOptionFocus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.checkResponses = this.checkResponses.bind(this);
        this.showOutcome = this.showOutcome.bind(this);
        this.show = this.show.bind(this);

        this.question = React.createRef();
    }

    componentDidMount() {
        this.randomiseOptions();
        this.setOptionCallbacks();
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.checkResponses();
        } else {
            this.getObjectStatus();
        }
        this.show();
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkObjectStatus: true
            });
        }

        if (this.state.lang !== nextProps.lang) {
            let progression_label = "";
            if (this.state.progression_label === this.state.try_again_label) {
                progression_label = appHelper.getLocaleString("try_again_label");
            } else if (this.state.progression_label === this.state.continue_label) {
                progression_label = appHelper.getLocaleString("continue_label");
            }
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                submit_label: appHelper.getLocaleString("submit_label"),
                multiple_choice_single_answer_question_label: appHelper.getLocaleString("multiple_choice_single_answer_question_label"),
                progression_label: progression_label,
                continue_label: appHelper.getLocaleString("continue_label"),
                try_again_label: appHelper.getLocaleString("try_again_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setReviewMode();
        }

        if (this.state.watchCheckBtnState) {
            //console.log(`${this.state.revealedOptions.length} >= ${this.props.screenObject.options.length}`)
            this.setCheckBtnState(this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW);
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.checkObjectStatus) {
            this.getObjectStatus();
        }

        if (this.state.handleCompletion) {
            this.handleProgression();
        }
        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }
        if (this.state.focusOnFeedback) {
            this.onFocusOnFeedback();
        }
        if (this.state.updateFocus) {
            this.setOptionFocus();
        }
    }

    show() {
        let question = this.question.current;
        if (appHelper.isDefined(question) && question !== null) {
            let params = {
                ele: question,
                duration: objectConstants.QUESTION_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.showHeight(params);
        }
    }

    onFocusOnFeedback() {
        let focusEl = document.getElementById(`feedback_wrapper_${this.state.screenObject.asset_id}`);
        if (appHelper.isDefined(focusEl) && focusEl !== null) {
            focusEl.focus();
        }
        this.setState({focusOnFeedback: false});
    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let interactionData = xAPIHelper.setSingleAnwserChoiceInteractionData(this.state.screenObject, this.state.responseData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {

            let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
            let category = {
                constant: componentConstants.GRID_CHOICE,
                label: componentConstants.GRID_CHOICE_LABEL
            };

            this.props.actions.postActvityStatement(screen, interactionData, category);
        }
    }

    handleSkipFeedback() {
        let latestResponse = appHelper.getLastItemOfArray(this.state.responseData.responses);
        let selectedOptions = [latestResponse.selectedOption.option_id];
        if (appHelper.isDefined(latestResponse.audio)) {
            let audio = appHelper.getAudioAsset(latestResponse.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

            //this.props.actions.setAudio(audioObj);
        }
        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: latestResponse.selectedOption.kpis !== null ? latestResponse.selectedOption.kpis : [],
            indicators: appHelper.isDefined(latestResponse.selectedOption.indicators) && latestResponse.selectedOption.indicators !== null ? latestResponse.selectedOption.indicators : [],
        };
        this.props.callbacks.storeUserResponse(responseObj);

        this.setState({skipFeedback: false});

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(latestResponse.selectedOption.character_pose)) {
            this.props.callbacks.updateCharacterExpression(latestResponse.selectedOption.character_pose);
        }

        if (!this.state.hasBadges) {

            let handleResponse = this.handleResponse;

            setTimeout(function () {
                handleResponse();
            }, 1000);
        }
    }

    checkResponses() {
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {

                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionData = xAPIHelper.getMultipleChoiceIds(params);

            this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                if (appHelper.isDefined(responseObj.statement) && appHelper.isDefined(responseObj.statement.result.completion)) {
                    this.setState({
                        xApiResponseObj: Object.assign({}, responseObj),
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            });
        }
    }

    getObjectStatus() {
        this.setState({checkObjectStatus: false});
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && this.state.usePreviousUserObjectData) {
            let screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
            if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                this.setState({
                    reviewMode: true,
                    propsUpdated: true,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    )
                });
            } else {
                let objectUserData = {};
                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    let subScreenParent = this.props.callbacks.getSubScreenParent();
                    let screen_id = this.props.callbacks.getScreenId();
                    if (appHelper.isDefined(subScreenParent)) {
                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                    } else {
                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                    }
                }

                if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                    this.setState({
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            }
        }
    }

    setReviewMode() {
        let optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
        let kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
        if (appHelper.isDefined(kpiUserData)) {
            let optionDetails = appHelper.getOptionParentDetails(kpiUserData.option_id[0]);
            let showResponse = false;

            if (appHelper.isDefined(optionDetails)) {
                let responses = [];
                let response = {
                    selectedOption: optionDetails.option
                };

                if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                    showResponse = true;
                }

                let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0 && this.showOutcome();
                let show_feedback_after_completion = optionDetails.option.feedback_settings.show_feedback_after_completion && this.showOutcome();
                let enable_feedback = optionDetails.option.enable_feedback && this.showOutcome();
                this.setState(
                    {
                        showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                        hasBadges: hasBadges,
                        badgesCollected: this.state.badgesCollected,
                        handleCompletion: true,
                        propsUpdated: false,
                        showOptions: true,
                        questionChecked: true,
                        currentlyChecked: true,
                        showCheckBtn: false,
                        showFeedback: show_feedback_after_completion && enable_feedback,
                        options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                        showResponse: showResponse,
                        progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                responses: dataHelper.immutablePush(responses, response),
                                latestResponse: optionDetails.option
                            }
                        )
                    }
                );
            }
        } else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let responseObj = Object.assign({}, this.state.xApiResponseObj);

            if (appHelper.isDefined(responseObj.statement)) {
                let responseString = responseObj.statement.result.response;
                let choices = responseObj.statement.object.definition.choices;
                //let optionResponse = xAPIHelper.getChoiceByDescription(choices, responseString);
                let optionResponse = xAPIHelper.getChoiceById(choices, responseString);
                if (appHelper.isDefined(optionResponse.id)) {

                    let optionDetails = appHelper.getOptionParentDetails(parseInt(optionResponse.id));
                    if (appHelper.isDefined(optionDetails)) {
                        let showResponse = false;
                        let responses = [];
                        let response = {
                            selectedOption: optionDetails.option
                        };

                        if (appHelper.isDefined(optionDetails.option.dialogs) && optionDetails.option.dialogs.length > 0) {
                            showResponse = true;
                        }
                        let show_feedback_after_completion = optionDetails.option.feedback_settings.show_feedback_after_completion && this.showOutcome();
                        let enable_feedback = optionDetails.option.enable_feedback && this.showOutcome();
                        let hasBadges = appHelper.isDefined(optionDetails.option.badges) && optionDetails.option.badges.length > 0 && this.showOutcome();
                        this.setState(
                            {
                                showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                                hasBadges: hasBadges,
                                badgesCollected: this.state.badgesCollected,
                                handleCompletion: true,
                                propsUpdated: false,
                                showOptions: true,
                                questionChecked: true,
                                currentlyChecked: true,
                                showCheckBtn: false,
                                showFeedback: show_feedback_after_completion && enable_feedback,
                                options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, optionDetails.option),
                                showResponse: showResponse,
                                progression_label: response.selectedOption.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                                responseData: Object.assign(
                                    {}, this.state.responseData,
                                    {
                                        responses: dataHelper.immutablePush(responses, response),
                                        latestResponse: optionDetails.option
                                    }
                                )
                            }
                        );
                    } else {
                        this.setState({
                            reviewMode: false,
                            propsUpdated: true,
                            usePreviousUserObjectData: false,
                            responseData: Object.assign(
                                {}, this.state.responseData,
                                {
                                    currentStatus: objectConstants.STATUS_NOT_STARTED,
                                    displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                                }
                            )
                        });
                    }
                } else {
                    this.setState({
                        reviewMode: false,
                        propsUpdated: true,
                        usePreviousUserObjectData: false,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_NOT_STARTED,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                            }
                        )
                    });
                }
            } else {
                this.setState({renderQuestions: true, propsUpdated: false, usePreviousUserObjectData: false,});
            }

        } else {
            this.setState({
                reviewMode: false,
                propsUpdated: false,
                usePreviousUserObjectData: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentStatus: objectConstants.STATUS_NOT_STARTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                    }
                )
            });
        }
    }


    scrollToSubmitBtn() {
        let submitBtn = this.refs[`${this.state.screenObject.asset_id}_check`];
        this.props.callbacks.scrollToSubmitBtn(submitBtn.offsetTop);
    }


    setCheckBtnState(state) {

        if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setState({showCheckBtn: state, watchCheckBtnState: false});
        }
    }

    onOptionRevealed(option) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
        if (index === -1) {
            this.setState(
                {
                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
                    watchCheckBtnState: true
                }
            );
        }

    }

    randomiseOptions() {
        if (this.state.screenObject.randomise_options) {
            let options = dataHelper.randomiseArray(this.state.options);
            this.setState({
                options: options,
                showOptions: true,
                focusedOption: options[0]
            });
        } else {
            this.setState({showOptions: true});
        }
        this.props.callbacks.scrollToTop();
    }


    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }

        this.props.callbacks.scrollToTop();
    }

    onOptionClick(event) {
        // console.log(this.state.responseData.latestResponse)
        let response = {
            selectedOption: appHelper.getObjectOption(this.state.screenObject.options, event.target.value)
        };
        // console.log(response.selectedOption);
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    //responses: dataHelper.immutablePush(this.state.responseData.responses, response),
                    latestResponse: Object.assign({}, response.selectedOption)
                }
            ),
            enableCheckBtn: true
        });
        this.scrollToSubmitBtn();
    }

    showOutcome() {
        return !this.state.screenObject.hide_outcome || (this.state.screenObject.hide_outcome && this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE);
    }

    checkAnswers() {
        let response = {
            selectedOption: this.state.responseData.latestResponse
        };
        let showResponse = false;
        if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
            showResponse = true;
        }
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();
        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback && !showResponse;
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
        this.setState({
            showOptions: true,
            responseData: Object.assign({}, this.state.responseData,
                {
                    responses: dataHelper.immutablePush(this.state.responseData.responses, response),
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED,
                    //latestResponse: Object.assign({}, this.state.responseData.latestResponse)
                }
            ),
            showFeedback: (enable_feedback && !showResponse),
            focusOnFeedback: (enable_feedback && !showResponse),
            skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
            showProgression: (!enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || (!enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN) && !showResponse && !hasBadges,
            progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            showResponse: showResponse,
            hasBadges: hasBadges,
            questionChecked: true,
            currentlyChecked: true,
            showCheckBtn: false,
            enableCheckBtn: false,

            checkPostXAPIResponse: true
        });
    }

    showFeedback() {
        // console.log("showFeedback");
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            this.setState({showFeedback: true, showOptions: false, focusOnFeedback: true});
        }
    }


    handleResponse() {
        this.setState({hideFeedback: false});
        let showResponse = false;
        if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
            showResponse = true;
        }

        let latestResponseFeedbackLocale = appHelper.getLocalData(this.state.responseData.latestResponse);

        let progressionRule = this.state.responseData.latestResponse.progression;
        if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        } else {
            let showResponse = false;
            if (appHelper.isDefined(this.state.responseData.latestResponse.dialogs) && this.state.responseData.latestResponse.dialogs.length > 0) {
                showResponse = true;
            }

            let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion && this.showOutcome();
            let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && progressionRule !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.hasFeedbackToShow();

            this.setState(
                {
                    showFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow() && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                    focusOnFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow() && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                    showOptions: true,
                    showResponse: showResponse,
                    options: dataHelper.immutableSplice(this.state.options, 0, this.state.options.length, this.state.responseData.latestResponse),
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,

                        }
                    )
                }
            );

            this.handleProgression();
        }

    }

    hasFeedbackToShow() {
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();
        return enable_feedback;
    }

    handleProgression() {
        /*l
        let navigateToNextScreen = true;
        this.props.callbacks.onObjectComplete(progressionRule, this.state.screenObject.asset_id, this.state.responseData.latestResponse, navigateToNextScreen);*/

        this.setState({handleCompletion: false});
        if (!this.state.progressionHandled) {
            this.setState({progressionHandled: true});
            let enable_feedback = this.state.responseData.latestResponse.enable_feedback;
            let progressionRule = this.state.responseData.latestResponse.progression;
            let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.responseData.latestResponse.progression_goto_id) ? this.state.responseData.latestResponse.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                index: this.props.index,
                showProgression: this.state.showProgression,
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
    }

    reattempt() {

        this.setState(
            {
                showFeedback: false,
                enableCheckBtn: false,
                showCheckBtn: true,
                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
                showOptions: true,
                showResponse: false,
                currentlyChecked: false,
                focusedOption: this.state.options[0],
                updateFocus: true,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
                        latestResponse: Object.assign({}, {}),

                    }
                )
            }
        );
    }

    //REVEW POPUP
    onReviewObject(sourceId) {

        if (this.hasFeedbackToShow()) {
            let config = Object.assign({}, MULTIPLE_CHOICE_REVIEW_CONFIG,
                {
                    title: this.state.locale.label,
                    sourceId: sourceId
                }
            );
            //locale.title

            for (let i = 0; i < config.childComponents.length; i++) {
                let child = config.childComponents[i];
                child.componentProps = Object.assign({}, {
                    screenObject: this.state.screenObject,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW
                        }
                    ),
                    callbacks: this.props.callbacks
                });
            }
            this.props.actions.setNewDialog(config);
        }
    }

    getClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW || this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED ? "multiple-choice-option-list" : "grid-choice-option-list";
    }

    handleResponseComplete() {
        let enable_feedback = this.state.responseData.latestResponse.enable_feedback && this.showOutcome();
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
        let progressionRule = this.state.responseData.latestResponse.progression;
        let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion;
        let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && progressionRule !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && enable_feedback;
        this.setState(
            {
                showFeedback: showFeedbackOnceComplete || (enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                focusOnFeedback: showFeedbackOnceComplete || (enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW),
                hasBadges: appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && !enable_feedback,
                skipFeedback: !enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                showProgression: (!enable_feedback && this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || (!enable_feedback && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !this.props.callbacks.hasNextObject(this.props.index) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN) || this.state.showProgression
            }
        );
    }

    getStatusClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.latestResponse.feedback_settings) && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
    }

    getTabIndex() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.latestResponse.feedback_settings) && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback ? 0 : -1;
    }

    onPanelClick() {

        if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.latestResponse.feedback_settings) && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback && this.hasFeedbackToShow()) {
            this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
        }
    }

    onKeyboardPanelClick(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.latestResponse.feedback_settings) && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback) {
                this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
            }
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setFocusedOption() {
        this.setState({focusedOption: Object.assign({}, this.state.options[0])});
    }

    clearFocusedOption() {
        this.setState({focusedOption: Object.assign({}, {})});
    }

    getPrevOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex - 1];
        if (optionIndex <= 0) {
            nextOption = this.state.options[this.state.options.length - 1];
        }

        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    getNextOption() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.options, "option_id", this.state.focusedOption.option_id);
        let nextOption = this.state.options[optionIndex + 1];
        if (optionIndex === (this.state.options.length - 1)) {
            nextOption = this.state.options[0];
        }
        this.setState({focusedOption: Object.assign({}, nextOption), updateFocus: true});
    }

    allowKeyAccessibility() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length) {
            return false;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.focusedOption.option_id) {
                    return false;
                }
            }
            return true;
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();

            if (this.allowKeyAccessibility()) {
                this.onOptionClick({target: {value: this.state.focusedOption.option_id}});
            } else {
                let responseData = this.state.responseData;
                if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED || responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && this.state.responseData.latestResponse.feedback_settings.include_explore_feedback) {
                    this.onReviewObject(`option_${this.state.focusedOption.option_id}`);
                }

            }
        }

        if (event.which === keyboardConstants.ARROW_LEFT_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_RIGHT_KEY) {
            event.preventDefault();
            this.getNextOption();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            this.getPrevOption();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            this.getNextOption();
        }
    }

    setOptionCallbacks() {
        this.setState({
            optionCallbacks: Object.assign({}, this.state.optionCallbacks, {
                setKeyboardAccessibility: this.setKeyboardAccessibility
            })
        });
    }

    setOptionFocus() {

        let focusEl = document.getElementById(`option_${this.state.focusedOption.option_id}`);
        focusEl.focus();
        this.setState({updateFocus: false});
    }

    enableProgression(progression_label) {
        let hasBadges = appHelper.isDefined(this.state.responseData.latestResponse.badges) && this.state.responseData.latestResponse.badges.length > 0 && this.showOutcome();
        let progressionType = appHelper.isDefined(this.state.responseData.latestResponse.progression_type) ? this.state.responseData.latestResponse.progression_type : undefined;
        let showProgression = !hasBadges;
        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            showProgression = (!hasBadges || hasBadges && this.state.badgesCollected) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TERMINAL;
        }
        this.setState({
            showProgression: showProgression,
            hasBadges: hasBadges,
            progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
        });
        this.props.callbacks.scrollToContinue();
    }

    onProgressionClicked() {
        let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = show_feedback_after_completion && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        let hideFeedback = !showFeedbackOnceComplete && (this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN);
        this.setState({
            showProgression: false,
            hideFeedback: hideFeedback,
        });

        if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.props.callbacks.navigateToNextScreen();
        } else if (this.props.callbacks.hasNextObject(this.props.index) && !hideFeedback) {
            this.handleResponse();
        } else if (this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        }
    }

    onBadgeCollected() {

        let show_feedback_after_completion = this.state.responseData.latestResponse.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        this.setState({badgesCollected: true, showFeedback: showFeedbackOnceComplete});
        if (!this.props.callbacks.hasNextObject(this.props.index)) {
            this.setState({
                showProgression: true,
                progression_label: this.state.responseData.latestResponse.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
            });
            this.props.callbacks.scrollToContinue();
        }
        this.handleResponse();

        //this.hide();
    }

    render() {
        return (
            <div className="a-c" ref={this.question}>
                <div className="learner-action">
                    <p className="hidden-el">{this.state.multiple_choice_single_answer_question_label}</p>
                    {
                        appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                            ?
                            <div className={`content-character-expression`}>
                                <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                            </div>
                            :
                            null
                    }
                    <div className={`question-wrapper ${this.getStatusClass()}`} tabIndex={this.getTabIndex()}
                         id={`question_wrapper_${this.state.screenObject.asset_id}`}
                         role="presentation" onClick={this.onPanelClick} onKeyDown={this.onKeyboardPanelClick}>
                        {
                            this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt
                                ?
                                this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                                    ?
                                    <div className="object-container">
                                        <DialogPrompt character_name={this.state.character_name}
                                                      screenObject={this.state.screenObject}
                                                      onComplete={this.onPromptRevealed}
                                                      animatePrompt={this.state.animatePrompt}
                                        />
                                    </div>
                                    :
                                    <QuestionPrompt screenObject={this.state.screenObject}
                                                    onComplete={this.onPromptRevealed}
                                                    animatePrompt={this.state.animatePrompt}
                                    />
                                :
                                null
                        }

                        {this.state.showOptions
                            ? <div className={`${this.getClass()} theme-active`}
                                   ref={`${this.state.screenObject.asset_id}_questionOptions`}
                                   role="radiogroup">
                                {this.state.options.map(option =>
                                    <Option key={option.option_id} option={option}
                                            asset_id={this.state.screenObject.asset_id}
                                            questionChecked={this.state.questionChecked}
                                            currentlyChecked={this.state.currentlyChecked}
                                            onOptionClick={this.onOptionClick}
                                            responseData={this.state.responseData}
                                            onAttemptComplete={this.showFeedback}
                                            onOptionRevealed={this.onOptionRevealed}
                                            onReviewObject={this.onReviewObject}
                                            focusedOption={this.state.focusedOption}
                                            optionCallbacks={this.state.optionCallbacks}
                                            index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                            showFeedback={appHelper.isDefined(this.state.responseData.latestResponse.enable_feedback) && this.state.responseData.latestResponse.enable_feedback}
                                            showOutcome={this.showOutcome()}
                                    />
                                )}
                            </div>
                            : null
                        }
                        {this.state.showCheckBtn
                            ? <div ref={`${this.state.screenObject.asset_id}_check`}>
                                <Button label={this.state.submit_label}
                                        id={`${this.state.screenObject.asset_id}_check_button`}
                                        isDisabled={!this.state.enableCheckBtn}
                                        onRevealed={this.props.callbacks.scrollToTop}
                                        onClick={this.checkAnswers}
                                />
                            </div>
                            : null
                        }
                        {this.state.showResponse || this.state.showFeedback
                            ?
                            <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 id={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                                 role="link"
                                 tabIndex={0}
                                 className="feedback-focus">
                                {this.state.showResponse
                                    ?
                                    <Conversation asset_id={this.state.screenObject.asset_id}
                                                  option_id={this.state.responseData.latestResponse.option_id}
                                                  dialogs={this.state.responseData.latestResponse.dialogs}
                                                  callbacks={this.props.callbacks}
                                                  onComplete={this.handleResponseComplete}/>
                                    :
                                    null
                                }
                                {
                                    this.state.showFeedback
                                        ? <Feedback screenObject={this.state.screenObject}
                                                    option={this.state.responseData.latestResponse}
                                                    options={this.state.screenObject.options}
                                                    asset_id={this.state.screenObject.asset_id}
                                                    responseData={this.state.responseData}
                                                    onComplete={this.handleResponse}
                                                    onShowReview={this.onReviewObject}
                                                    callbacks={this.props.callbacks}
                                                    onEnableProgression={this.enableProgression}
                                                    hideFeedback={this.state.hideFeedback}
                                                    index={this.props.index}
                                                    showImages={this.state.show_images_in_feedback}/>
                                        : null
                                }
                            </div>
                            : null
                        }
                        {(this.state.showResponse || this.state.showFeedback) && this.state.hasBadges
                            ?
                            <br/>
                            :
                            null
                        }
                        {
                            this.state.hasBadges
                                ?
                                <div className="badge-wrapper">
                                    {this.state.responseData.latestResponse.badges.map(badge =>
                                        <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                      bite_id={this.props.callbacks.getBiteId()}
                                                      asset_id={this.state.screenObject.asset_id}
                                                      onCollected={this.onBadgeCollected}
                                                      animate={this.state.animateBadge}
                                        />
                                    )}
                                </div>
                                : null
                        }
                    </div>
                    {this.state.showProgression
                        ?
                        <Button label={this.state.progression_label} id={`${this.state.screenObject.asset_id}_button`}
                                ref={`${this.state.screenObject.asset_id}_button`}
                                onClick={this.onProgressionClicked}/>
                        : null

                    }
                </div>
            </div>
        );
    }
}

GridChoice.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

GridChoice.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GridChoice);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/gridChoice/GridChoice.js
 **/